/* eslint-disable jsx-a11y/accessible-emoji */
import type React from 'react';
import styled from 'styled-components';

export type CheerUp = React.ReactNode | string;
type CheerUps = Record<number, CheerUp[]>;

export const Emoji = styled.span.attrs({
  role: 'img',
})`
  font-style: normal;
`;

export const cheerUps: CheerUps = {
  0: [
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <span>Nice </span>
      <Emoji>👍</Emoji>
    </>,
    'Good job!',
    'Way to go!',
    'You got this!',
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <span>Crushing it </span>
      <Emoji>😉</Emoji>
    </>,
    'Amazing!',
  ],
  15: [
    'You’re really, really good at this',
    'That was your best yet!',
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <span>Vroom vroom </span>
      <Emoji>🚗</Emoji>
    </>,
    'Noise',
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <span>BOOM </span>
      <Emoji>💥</Emoji>
    </>,
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <span>Put some wheels on it </span>
      <Emoji>🎡</Emoji>
    </>,
    'Born to run, baby',
    'Tramps like you were born to run',
    'Life is a highway',
    'Are you a professional driver?',
    'License to crush',
    'Own the road',
    'You better work',
    'Shut up and drive',
    'Baby, you can drive my car',
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <span>You rock </span>
      <Emoji>🗿</Emoji>
    </>,
  ],
  40: [
    'You here for games or insurance?',
    'Are you the best driver ever?',
    'So fast, so curious',
    'Now That’s What I Call Car, vol 5',
    'Ride or die (don’t die)',
    'Wheeeeeeel smooth',
    'You are a GOD of the road!',
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    <>
      <Emoji>🚗⚡️🚗⚡️🚗⚡️🚗⚡️🚗⚡️🚗⚡️🚗⚡️</Emoji>
    </>,
    'Do a barrel roll',
    'Four wheels, zero brakes',
    'Livin’ life a 1/4 mile at a time',
    'Sally? You drive like a Mustang!',
    'Your tires are burning',
    'I’m-a gonna win!',
    'Mario who?',
  ],
};

export const replayGame = [
  'Do you have nothing else to do?',
  'You could have bought a policy 3 times by now…',
  'This is why they’re getting rid of WFH',
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <>
    <span>Should we send you a prize? </span>
    <Emoji>😳</Emoji>
  </>,
  'Careful, this is actually a time machine',
  'Okay, move on with your life',
  'We knew you’d love this',
  'Come on, it’s not that fun!',
  'Go touch grass',
  'This is very Black Mirror of you',
];
